import { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  DialogActions,
  Button,
  InputAdornment,
  Typography,
  IconButton,
} from '@mui/material';
import { RHFSelect, RHFTextField } from '../hook-form';
import { LoadingButton } from '@mui/lab';
import { enqueueSnackbar } from 'notistack';
import { yupResolver } from '@hookform/resolvers/yup';
import FormProvider from '../hook-form/form-provider';
import { postRequest } from 'src/services';
import * as Yup from 'yup';
import { useForm, useFieldArray } from 'react-hook-form';

import { handleErrorMessages } from '../risk-management/risk-register/feching';
import Iconify from '../iconify';
import { Descriptions } from './dropdown-descirption';
import { calculateTotalCosts, reCalculateAllTotals } from './activity-models-calculations';

const ModalPercentages = ({ type, index, PercentIcon, hideDetails, calculationOfTotalCosts }) => {
  return (
    <>
      {!hideDetails ? (
        <>
          <RHFTextField
            type="number"
            name={`${type}[${index}].labor_cost`}
            label="% of Labor Cost"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {PercentIcon}
                  </Box>
                </InputAdornment>
              ),
            }}
            onChange={(e) =>
              calculationOfTotalCosts(e.target.value, `${type}[${index}].labor_cost`)
            }
          />
          <RHFTextField
            type="number"
            name={`${type}[${index}].material_cost`}
            label="% of Material Cost"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {PercentIcon}
                  </Box>
                </InputAdornment>
              ),
            }}
            onChange={(e) =>
              calculationOfTotalCosts(e.target.value, `${type}[${index}].material_cost`)
            }
          />
          <RHFTextField
            type="number"
            name={`${type}[${index}].equipment_cost`}
            label="% of Equipment Cost"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {PercentIcon}
                  </Box>
                </InputAdornment>
              ),
            }}
            onChange={(e) =>
              calculationOfTotalCosts(e.target.value, `${type}[${index}].equipment_cost`)
            }
          />
          <RHFTextField
            type="number"
            name={`${type}[${index}].subcontractor_cost`}
            label="% of Subcontractor Cost"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {PercentIcon}
                  </Box>
                </InputAdornment>
              ),
            }}
            onChange={(e) =>
              calculationOfTotalCosts(e.target.value, `${type}[${index}].subcontractor_cost`)
            }
          />
          <RHFTextField
            type="number"
            name={`${type}[${index}].other_cost`}
            label="% of Other Cost"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {PercentIcon}
                  </Box>
                </InputAdornment>
              ),
            }}
            onChange={(e) =>
              calculationOfTotalCosts(e.target.value, `${type}[${index}].other_cost`)
            }
          />
        </>
      ) : (
        <RHFTextField
          type="number"
          name={`${type}[${index}].overall_cost`}
          label="% on Overall"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Box component="span" sx={{ color: 'text.disabled' }}>
                  {PercentIcon}
                </Box>
              </InputAdornment>
            ),
          }}
          onChange={(e) =>
            calculationOfTotalCosts(e.target.value, `${type}[${index}].overall_cost`)
          }
        />
      )}
    </>
  );
};

export default ModalPercentages;
